import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPracticeLandingRoute: InvariantJiraRoute = {
	name: 'servicedesk-practice-landing',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/(custom)?',
	exact: true,
};
